var _defs, _tspan;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOneFault(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 368.293,
    height: 305.704,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.72 41.96h291.985v232.72H47.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h360v288H0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-44.54 27.366h360v-288h-360z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.72 41.96h291.985v232.72H47.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h360v288H0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "g",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-99.758 27.366h360v-288h-360z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "h",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.72 41.96h291.985v232.72H47.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h360v288H0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "j",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-158.155 27.366h360v-288h-360z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "k",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.72 41.96h291.985v232.72H47.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "l",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h360v288H0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "m",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-216.552 27.366h360v-288h-360z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "n",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.72 41.96h291.985v232.72H47.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "o",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h360v288H0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "p",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-274.949 27.366h360v-288h-360z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "q",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.72 41.96h291.985v232.72H47.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "r",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h360v288H0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "s",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-330.166 27.366h360v-288h-360z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "t",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-118.666 13.694h360v-288h-360z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "u",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.72 41.96h291.985v232.72H47.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "v",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h360v288H0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "w",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-24.814 38.163h360v-288h-360z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "x",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.72 41.96h291.985v232.72H47.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "y",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h360v288H0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "z",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-24.814 80.476h360v-288h-360z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "A",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.72 41.96h291.985v232.72H47.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "B",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h360v288H0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "C",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-24.814 122.789h360v-288h-360z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "D",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.72 41.96h291.985v232.72H47.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "E",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h360v288H0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "F",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-24.814 165.101h360v-288h-360z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "G",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.72 41.96h291.985v232.72H47.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "H",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h360v288H0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "I",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-24.814 207.414h360v-288h-360z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "J",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.72 41.96h291.985v232.72H47.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "K",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h360v288H0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "L",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-24.814 249.727h360v-288h-360z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "M",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-109.797-18.736v360h288v-360z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "N",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.72 41.96h291.985v232.72H47.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "O",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.72 41.96h291.985v232.72H47.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "P",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h360v288H0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Q",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h360v288H0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "R",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h360v288H0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "S",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h360v288H0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "T",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h360v288H0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "U",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h360v288H0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "V",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-220.799 67.71h360v-288h-360z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "W",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h360v288H0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "X",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-220.799 53.038h360v-288h-360z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8585.796 811.17h368.898V521.944h-368.898z"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "translate(-8586.073 -507.515)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.72 41.96v232.72",
    clipPath: "url(#b)",
    style: {
      fill: "none",
      stroke: "#b0b0b0",
      strokeWidth: 0.8,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.09141 0 0 -1.09141 8573.79 823.175)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.72 41.96v-3.5",
    clipPath: "url(#c)",
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.8,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.09141 0 0 -1.09141 8573.79 823.175)"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    clipPath: "url(#d)",
    transform: "translate(8622.402 793.307)scale(1.09141)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 400,
      fontSize: 10,
      fontFamily: "&quot",
      writingMode: "lr-tb",
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "0")), /*#__PURE__*/React.createElement("path", {
    d: "M106.117 41.96v232.72",
    clipPath: "url(#e)",
    style: {
      fill: "none",
      stroke: "#b0b0b0",
      strokeWidth: 0.8,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.09141 0 0 -1.09141 8573.79 823.175)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.117 41.96v-3.5",
    clipPath: "url(#f)",
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.8,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.09141 0 0 -1.09141 8573.79 823.175)"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    clipPath: "url(#g)",
    transform: "translate(8682.667 793.307)scale(1.09141)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: "0 6.3600001",
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 400,
      fontSize: 10,
      fontFamily: "&quot",
      writingMode: "lr-tb",
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "20")), /*#__PURE__*/React.createElement("path", {
    d: "M164.514 41.96v232.72",
    clipPath: "url(#h)",
    style: {
      fill: "none",
      stroke: "#b0b0b0",
      strokeWidth: 0.8,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.09141 0 0 -1.09141 8573.79 823.175)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.514 41.96v-3.5",
    clipPath: "url(#i)",
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.8,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.09141 0 0 -1.09141 8573.79 823.175)"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    clipPath: "url(#j)",
    transform: "translate(8746.403 793.307)scale(1.09141)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: "0 6.3600001",
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 400,
      fontSize: 10,
      fontFamily: "&quot",
      writingMode: "lr-tb",
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "40")), /*#__PURE__*/React.createElement("path", {
    d: "M222.911 41.96v232.72",
    clipPath: "url(#k)",
    style: {
      fill: "none",
      stroke: "#b0b0b0",
      strokeWidth: 0.8,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.09141 0 0 -1.09141 8573.79 823.175)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.911 41.96v-3.5",
    clipPath: "url(#l)",
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.8,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.09141 0 0 -1.09141 8573.79 823.175)"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    clipPath: "url(#m)",
    transform: "translate(8810.138 793.307)scale(1.09141)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: "0 6.3600001",
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 400,
      fontSize: 10,
      fontFamily: "&quot",
      writingMode: "lr-tb",
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "60")), /*#__PURE__*/React.createElement("path", {
    d: "M281.308 41.96v232.72",
    clipPath: "url(#n)",
    style: {
      fill: "none",
      stroke: "#b0b0b0",
      strokeWidth: 0.8,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.09141 0 0 -1.09141 8573.79 823.175)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.308 41.96v-3.5",
    clipPath: "url(#o)",
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.8,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.09141 0 0 -1.09141 8573.79 823.175)"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    clipPath: "url(#p)",
    transform: "translate(8873.873 793.307)scale(1.09141)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: "0 6.3600001",
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 400,
      fontSize: 10,
      fontFamily: "&quot",
      writingMode: "lr-tb",
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "80")), /*#__PURE__*/React.createElement("path", {
    d: "M339.705 41.96v232.72",
    clipPath: "url(#q)",
    style: {
      fill: "none",
      stroke: "#b0b0b0",
      strokeWidth: 0.8,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.09141 0 0 -1.09141 8573.79 823.175)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.705 41.96v-3.5",
    clipPath: "url(#r)",
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.8,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.09141 0 0 -1.09141 8573.79 823.175)"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    clipPath: "url(#s)",
    transform: "translate(8934.138 793.307)scale(1.09141)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: "0 6.3600001 12.72",
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 400,
      fontSize: 10,
      fontFamily: "&quot",
      writingMode: "lr-tb",
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "100")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    clipPath: "url(#t)",
    transform: "translate(8703.304 808.229)scale(1.09141)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: "0 7.48 13.82 23.559999 29.91 36.060001 40.169998 43.349998 49.470001 52.990002 56.169998 59.689999 65.82 72.160004 74.940002 78.860001 84.779999 87.959999 93.169998 95.949997 102.3 108.64 114.77 118.69 125.03 129.14 135.28999 140.5 143.67999",
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 400,
      fontSize: 10,
      fontFamily: "&quot",
      writingMode: "lr-tb",
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "Number of faulty signatures q")), /*#__PURE__*/React.createElement("path", {
    d: "M47.72 41.96h291.985",
    clipPath: "url(#u)",
    style: {
      fill: "none",
      stroke: "#b0b0b0",
      strokeWidth: 0.8,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.09141 0 0 -1.09141 8573.79 823.175)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.72 41.96h-3.5",
    clipPath: "url(#v)",
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.8,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.09141 0 0 -1.09141 8573.79 823.175)"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    clipPath: "url(#w)",
    transform: "translate(8600.872 781.523)scale(1.09141)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: "0 6.3600001 9.54",
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 400,
      fontSize: 10,
      fontFamily: "&quot",
      writingMode: "lr-tb",
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "0.0")), /*#__PURE__*/React.createElement("path", {
    d: "M47.72 84.273h291.985",
    clipPath: "url(#x)",
    style: {
      fill: "none",
      stroke: "#b0b0b0",
      strokeWidth: 0.8,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.09141 0 0 -1.09141 8573.79 823.175)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.72 84.273h-3.5",
    clipPath: "url(#y)",
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.8,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.09141 0 0 -1.09141 8573.79 823.175)"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    clipPath: "url(#z)",
    transform: "translate(8600.872 735.342)scale(1.09141)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: "0 6.3600001 9.54",
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 400,
      fontSize: 10,
      fontFamily: "&quot",
      writingMode: "lr-tb",
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "0.2")), /*#__PURE__*/React.createElement("path", {
    d: "M47.72 126.585h291.985",
    clipPath: "url(#A)",
    style: {
      fill: "none",
      stroke: "#b0b0b0",
      strokeWidth: 0.8,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.09141 0 0 -1.09141 8573.79 823.175)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.72 126.585h-3.5",
    clipPath: "url(#B)",
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.8,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.09141 0 0 -1.09141 8573.79 823.175)"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    clipPath: "url(#C)",
    transform: "translate(8600.872 689.162)scale(1.09141)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: "0 6.3600001 9.54",
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 400,
      fontSize: 10,
      fontFamily: "&quot",
      writingMode: "lr-tb",
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "0.4")), /*#__PURE__*/React.createElement("path", {
    d: "M47.72 168.898h291.985",
    clipPath: "url(#D)",
    style: {
      fill: "none",
      stroke: "#b0b0b0",
      strokeWidth: 0.8,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.09141 0 0 -1.09141 8573.79 823.175)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.72 168.898h-3.5",
    clipPath: "url(#E)",
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.8,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.09141 0 0 -1.09141 8573.79 823.175)"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    clipPath: "url(#F)",
    transform: "translate(8600.872 642.981)scale(1.09141)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: "0 6.3600001 9.54",
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 400,
      fontSize: 10,
      fontFamily: "&quot",
      writingMode: "lr-tb",
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "0.6")), /*#__PURE__*/React.createElement("path", {
    d: "M47.72 211.21h291.985",
    clipPath: "url(#G)",
    style: {
      fill: "none",
      stroke: "#b0b0b0",
      strokeWidth: 0.8,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.09141 0 0 -1.09141 8573.79 823.175)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.72 211.21h-3.5",
    clipPath: "url(#H)",
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.8,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.09141 0 0 -1.09141 8573.79 823.175)"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    clipPath: "url(#I)",
    transform: "translate(8600.872 596.8)scale(1.09141)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: "0 6.3600001 9.54",
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 400,
      fontSize: 10,
      fontFamily: "&quot",
      writingMode: "lr-tb",
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "0.8")), /*#__PURE__*/React.createElement("path", {
    d: "M47.72 253.524h291.985",
    clipPath: "url(#J)",
    style: {
      fill: "none",
      stroke: "#b0b0b0",
      strokeWidth: 0.8,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.09141 0 0 -1.09141 8573.79 823.175)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.72 253.524h-3.5",
    clipPath: "url(#K)",
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.8,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.09141 0 0 -1.09141 8573.79 823.175)"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    clipPath: "url(#L)",
    transform: "translate(8600.872 550.62)scale(1.09141)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: "0 6.3600001 9.54",
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 400,
      fontSize: 10,
      fontFamily: "&quot",
      writingMode: "lr-tb",
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "1.0")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    clipPath: "url(#M)",
    transform: "rotate(-90 4648.79 -3945.449)scale(1.09141)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: "0 6.3499999 12.69 18.190001 23.690001 29.84 35.049999 40.259998 43.439999 49.790001 53.900002 60.02 66.370003 72.5 78.849998 81.629997 84.410004 87.190002 91.110001",
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 400,
      fontSize: 10,
      fontFamily: "&quot",
      writingMode: "lr-tb",
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "Success probability")), /*#__PURE__*/React.createElement("path", {
    d: "M47.72 41.96h8.76l2.92.01 2.92.056 2.92.178 2.919.419 2.92.788 2.92 1.272 2.92 1.843 2.92 2.46 2.92 3.083 2.919 3.688 2.92 4.246 2.92 4.744 2.92 5.172 2.92 5.525 2.92 5.807 2.92 6.017 2.919 6.163 2.92 6.25 2.92 6.283 2.92 6.27 2.92 6.22 2.92 6.132 2.92 6.018 2.919 5.88 2.92 5.725 2.92 5.554 2.92 5.372 2.92 5.183 2.92 4.988 2.919 4.79 2.92 4.591 2.92 4.394 2.92 4.197 2.92 4.003 2.92 3.814 2.92 3.63 2.919 3.45 2.92 3.275 2.92 3.108 2.92 2.945 2.92 2.79 2.92 2.641 2.92 2.498 2.919 2.361 2.92 2.23 2.92 2.107 2.92 1.988 2.92 1.876 2.92 1.769 2.919 1.667 2.92 1.571 2.92 1.48 2.92 1.394 2.92 1.312 2.92 1.235 2.92 1.162 2.919 1.094 2.92 1.028 2.92.967 2.92.909 2.92.854 2.92.803 2.92.755 2.919.709 2.92.666 2.92.626 2.92.587 2.92.552 2.92.518 2.919.487 2.92.457 2.92.429 2.92.402 2.92.378 2.92.354 2.92.333 2.919.312 2.92.293 2.92.275 2.92.258 2.92.242 2.92.227 2.92.213 2.919.2 2.92.187 2.92.176 2.92.165 2.92.155 2.92.145 2.919.136 2.92.127 2.92.12 2.92.112 2.92.106 2.92.098 2.92.093 2.919.087",
    clipPath: "url(#N)",
    style: {
      fill: "none",
      stroke: "#1f77b4",
      strokeWidth: 1.5,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.09141 0 0 -1.09141 8573.79 823.175)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m76.919 43.467 2.92 1.31 2.92 1.88 2.919 2.644 2.92 3.422 2.92 3.486 2.92 4.915 2.92 4.394 2.92 5.522 2.92 6.932 2.919 4.594 2.92 7.277 2.92 6.03 2.92 5.7 2.92 5.674 2.92 6.853 2.92 8.144 2.919 4.938 2.92 5.508 2.92 5.663 2.92 6.538 2.92 4.549 2.92 5.054 2.919 5.764 2.92 4.554 2.92 3.47 2.92 5.641 2.92 4.583 2.92 4.685 2.92 3.705 2.919 3.927 2.92 4.134 2.92 1.677 2.92 4.372 2.92 2.836 2.92 2.465 2.92 2.54 2.919 1.81 2.92 3.278 2.92 3.45 2.92.482 2.92 2.537 2.92 2.179 2.919 1.854 2.92 1.796 2.92 2.373 2.92.977 2.92 1.459 2.92.084 2.92 2.59 2.919 1.259 2.92.813 2.92 1.666 2.92.163 2.92 2.029 2.92.11 2.92 1.36 2.919.696 2.92-.019 2.92 1.254 2.92.633 2.92 1.14 2.92-.057 2.919.76 2.92 1.4 2.92-1.282 2.92.768 2.92 1.112 2.92.22 2.92-.02 2.919 1.127 2.92-.243 2.92.567 2.92-.142 2.92.57 2.92.08 2.92.287 2.919.02 2.92.904 2.92-.31 2.92.145 2.92.206 2.92.186 2.919-.041 2.92.518 2.92-.062 2.92.207 2.92.104 2.92.042 2.92-.042 2.919.167",
    clipPath: "url(#O)",
    style: {
      fill: "none",
      stroke: "#ff7f0e",
      strokeWidth: 1.5,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.09141 0 0 -1.09141 8573.79 823.175)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.72 41.96v232.72",
    clipPath: "url(#P)",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.8,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.09141 0 0 -1.09141 8573.79 823.175)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.705 41.96v232.72",
    clipPath: "url(#Q)",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.8,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.09141 0 0 -1.09141 8573.79 823.175)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.72 41.96h291.985",
    clipPath: "url(#R)",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.8,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.09141 0 0 -1.09141 8573.79 823.175)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.72 274.68h291.985",
    clipPath: "url(#S)",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.8,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.09141 0 0 -1.09141 8573.79 823.175)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.799 46.96h141.906q2 0 2 2v28.344q0 2-2 2H190.799q-2 0-2-2V48.96q0-2 2-2z",
    clipPath: "url(#T)",
    style: {
      fill: "#fff",
      fillOpacity: 0.8,
      fillRule: "nonzero",
      stroke: "#ccc",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 0.8
    },
    transform: "matrix(1.09141 0 0 -1.09141 8573.79 823.175)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.799 71.21h20",
    clipPath: "url(#U)",
    style: {
      fill: "none",
      stroke: "#1f77b4",
      strokeWidth: 1.5,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.09141 0 0 -1.09141 8573.79 823.175)"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    clipPath: "url(#V)",
    transform: "translate(8814.773 749.275)scale(1.09141)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: "0 6.8400002 13.19 19.540001 23.65 29.77 35.689999 38.470001 48.209999 54.34 58.259998 61.040001 67.160004 73.5 76.68 80.580002 86.900002 93.25 96.43 99.610001 105.97",
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 400,
      fontSize: 10,
      fontFamily: "&quot",
      writingMode: "lr-tb",
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "Approximation (Eq. 1)")), /*#__PURE__*/React.createElement("path", {
    d: "M192.799 56.538h20",
    clipPath: "url(#W)",
    style: {
      fill: "none",
      stroke: "#ff7f0e",
      strokeWidth: 1.5,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.09141 0 0 -1.09141 8573.79 823.175)"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    clipPath: "url(#X)",
    transform: "translate(8814.773 765.288)scale(1.09141)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: "0 6.3499999 9.1300001 18.870001 25.209999 27.99 34.119999 38.040001 40.82 46.939999",
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 400,
      fontSize: 10,
      fontFamily: "&quot",
      writingMode: "lr-tb",
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "Simulation"))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    x: 39.525,
    y: 11.398,
    style: {
      fill: "#000"
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 39.525,
    y: 11.398
  }, "SPHINCS Attack Performance"))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOneFault);
export default __webpack_public_path__ + "static/media/oneFault.e7a862526e29d7c63217017767c4447c.svg";
export { ForwardRef as ReactComponent };